import { useState } from "react";
import { useTranslation } from "react-i18next";

const FAQ_ITEMS = [
  { q: "faq.q1", a: "faq.a1" },
  { q: "faq.q2", a: "faq.a2" },
  { q: "faq.q3", a: "faq.a3" },
  { q: "faq.q4", a: "faq.a4" },
  { q: "faq.q5", a: "faq.a5" },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_ITEMS.map((item) => ({
      "@type": "Question",
      name: t(item.q),
      acceptedAnswer: { "@type": "Answer", text: t(item.a) },
    })),
  };

  return (
    <section id="faq" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <div className="mx-auto max-w-2xl text-center">
        <span className="text-xs font-semibold uppercase tracking-wide text-primary-600">
          {t("faq.eyebrow")}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
          {t("faq.title")}
        </h2>
      </div>

      <div className="mx-auto mt-10 max-w-3xl space-y-3">
        {FAQ_ITEMS.map((item, index) => {
          const isOpen = open === index;
          return (
            <div
              key={item.q}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : index)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-semibold text-foreground-900 md:text-base">
                  {t(item.q)}
                </span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                  }`}
                >
                  <i className={`text-base ${isOpen ? "ri-subtract-line" : "ri-add-line"}`} />
                </span>
              </button>
              {isOpen && (
                <div className="px-5 pb-5">
                  <p className="text-sm leading-relaxed text-foreground-600">{t(item.a)}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}